import React from "react";
import { makeStyles, SearchBox } from "@fluentui/react-components";
import type {
  SearchBoxChangeEvent,
  InputOnChangeData,
} from "@fluentui/react-components";

const useStyles = makeStyles({
  searchBox: {
    flexGrow: 1,
    minWidth: "150px",
    maxWidth: "400px",
  },
});

interface DimensionSearchProps {
  dimensionLabel: string;
  value: string;
  onChange: (value: string) => void;
}

export const DimensionSearch: React.FC<DimensionSearchProps> = ({
  dimensionLabel,
  value,
  onChange,
}) => {
  const styles = useStyles();

  const handleChange = (_: SearchBoxChangeEvent, data: InputOnChangeData) => {
    onChange(data.value);
  };

  return (
    <SearchBox
      className={styles.searchBox}
      placeholder={`Search ${dimensionLabel}...`}
      value={value}
      onChange={handleChange}
      size="medium"
    />
  );
};
